// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mortgage-connections-container .buyer-modal {
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.85);
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mortgage-connections-container .buyer-modal.visible {
  opacity: 1;
  visibility: visible;
}
.mortgage-connections-container .buyer-modal .modal-container {
  font-family: "Proxima Nova", sans-serif;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);
  border-radius: 25px;
  width: 660px;
  padding: 30px;
}
.mortgage-connections-container .buyer-modal .modal-container .modal-title {
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
  position: relative;
}
.mortgage-connections-container .buyer-modal .modal-container .modal-title .close {
  position: absolute;
  right: 0;
  cursor: pointer;
}
.mortgage-connections-container .buyer-modal .modal-container .buyer-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(0, 0, 0, 0.1490196078);
}
.mortgage-connections-container .buyer-modal .modal-container .buyer-details .buyer-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 3px solid white;
  border-radius: 50px;
  margin-right: 10px;
}
.mortgage-connections-container .buyer-modal .modal-container .buyer-details .name {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.mortgage-connections-container .buyer-modal .modal-container .buyer-details .content {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
  justify-content: center;
}
.mortgage-connections-container .buyer-modal .modal-container .buyer-details .content > div {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondary-color-5);
}
.mortgage-connections-container .buyer-modal .modal-container button.save {
  width: 100%;
  border-radius: 10px;
  height: 45px;
  font-size: 16px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/routes/MortgageDashboard/modules/MortgageConnections/modules/BuyerInfoModal/buyerInfoModal.scss"],"names":[],"mappings":"AACI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,2CAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AACQ;EACI,UAAA;EACA,mBAAA;AACZ;AACQ;EACI,uCAAA;EACA,mBAAA;EACA,kDAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACZ;AAAY;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AAEhB;AADgB;EACI,kBAAA;EACA,QAAA;EACA,eAAA;AAGpB;AAAY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;AAEhB;AADgB;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAGpB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AAGpB;AADgB;EACI,aAAA;EACA,uCAAA;EACA,uBAAA;AAGpB;AAFoB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AAIxB;AAAY;EACI,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAEhB","sourcesContent":[".mortgage-connections-container {\r\n    .buyer-modal {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        height: 100vh;\r\n        width: 100vw;\r\n        transition: .3s ease-in-out;\r\n        position: fixed;\r\n        background-color: rgba($color: white, $alpha: .85);\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 999;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        &.visible {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        .modal-container {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            background: #FFFFFF;\r\n            box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);\r\n            border-radius: 25px;\r\n            width: 660px;\r\n            padding: 30px;\r\n            .modal-title {\r\n                display: flex;\r\n                justify-content: center;\r\n                font-weight: 700;\r\n                font-size: 20px;\r\n                color: var(--secondary-color-1);\r\n                position: relative;\r\n                .close {\r\n                    position: absolute;\r\n                    right: 0;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n            .buyer-details {\r\n                display: flex;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                justify-content: center;\r\n                border-top: 1px solid #00000026;\r\n                .buyer-image {\r\n                    width: 100px;\r\n                    height: 100px;\r\n                    object-fit: cover;\r\n                    border: 3px solid white;\r\n                    border-radius: 50px;\r\n                    margin-right: 10px;\r\n                }\r\n                .name {\r\n                    font-size: 24px;\r\n                    font-weight: 700;\r\n                    margin: 0;\r\n                }\r\n                .content {\r\n                    display: flex;\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    justify-content: center;\r\n                    > div {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        color: var(--secondary-color-5);\r\n                    }                              \r\n                }\r\n            } \r\n            button.save {\r\n                width: 100%;\r\n                border-radius: 10px;\r\n                height: 45px;\r\n                font-size: 16px;\r\n                font-weight: 700;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
